import { RequestForm } from "../components";

export const Request = () => {
  return <RequestForm />;
};
